exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.breadcrumb[data-v-f31d0a4c] {\n    background-color: #35495E;\n    color: white;\n    height: 55px;\n    line-height: 50px;\n    padding-left: 10px;\n}\n.router-view-content[data-v-f31d0a4c] {\n    padding: 10px;\n}\n\n", ""]);

